/**
 * Vivia UTM Capture & Cart Attribution
 *
 * Persists Meta-dynamic UTMs (utm_source/medium/campaign/content/term) across
 * page loads and writes them into cart.attributes — so when a customer
 * checks out, the order in Shopify Admin shows which ad drove the purchase.
 *
 * Behavior:
 *  1. On any landing with ?utm_*= in URL: capture to localStorage (90-day TTL,
 *     LAST-TOUCH wins — matches Meta's 7-day click default).
 *  2. On every page load (once per browser session): read localStorage, write
 *     to /cart/update.js so cart.attributes contain the UTMs. Shopify carries
 *     cart.attributes through to order.note_attributes at checkout.
 *  3. Order attribution then visible at:
 *     Shopify Admin → Orders → Order detail → "Additional details" section
 *     (and via Admin API note_attributes).
 */
(function() {
  'use strict';

  var STORAGE_KEY  = 'vivia_utm';
  var SESSION_FLAG = 'vivia_utm_synced';
  var TTL_MS       = 90 * 24 * 60 * 60 * 1000;
  var UTM_KEYS     = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

  // ---- Step 1: capture from URL (last-touch wins) ----
  try {
    var params  = new URLSearchParams(window.location.search);
    var captured = {};
    var hasAny  = false;
    UTM_KEYS.forEach(function(k) {
      var v = params.get(k);
      if (v) { captured[k] = v; hasAny = true; }
    });
    if (hasAny) {
      captured._t          = Date.now();
      captured._first_page = window.location.pathname;
      captured._referrer   = document.referrer || '';
      localStorage.setItem(STORAGE_KEY, JSON.stringify(captured));
      sessionStorage.removeItem(SESSION_FLAG);  // force re-sync with the new UTMs
      console.log('[vivia-utm] captured:', captured);
    }
  } catch (e) {
    console.warn('[vivia-utm] capture error:', e && e.message);
  }

  // ---- Step 2: sync to cart.attributes (once per session) ----
  try {
    if (sessionStorage.getItem(SESSION_FLAG) === '1') return;

    var stored = null;
    try { stored = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null'); } catch (e) {}
    if (!stored) return;

    if ((Date.now() - (stored._t || 0)) > TTL_MS) {
      localStorage.removeItem(STORAGE_KEY);
      return;
    }

    var pairs = [];
    UTM_KEYS.forEach(function(k) {
      if (stored[k]) {
        pairs.push('attributes[' + encodeURIComponent(k) + ']=' + encodeURIComponent(stored[k]));
      }
    });
    if (stored._first_page) {
      pairs.push('attributes[utm_first_page]=' + encodeURIComponent(stored._first_page));
    }
    if (pairs.length === 0) return;

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: pairs.join('&'),
      credentials: 'same-origin'
    }).then(function(r) {
      if (r.ok) {
        sessionStorage.setItem(SESSION_FLAG, '1');
        console.log('[vivia-utm] cart.attributes synced (' + pairs.length + ' attrs)');
      } else {
        console.warn('[vivia-utm] /cart/update.js HTTP', r.status);
      }
    }).catch(function(e) {
      console.warn('[vivia-utm] sync error:', e && e.message);
    });
  } catch (e) {
    console.warn('[vivia-utm] sync block error:', e && e.message);
  }
})();
